/// <reference path="../MainViewController.ts" />

/**
 * Root view controller when AppMode = shell (manager.dual-link.com).
 *
 * It only provides the full-window content view the cluster manager iframes are
 * placed in; the login and the workspace picker are presented over it exactly as
 * over the desktop or phone root, and ClusterSessionController does the rest.
 */
class ShellViewController extends MainViewController
{
    protected workspaceDidChange(business:Business) {
        // Never fires in shell mode: the workspace is opened inside the cluster manager.
    }
}
